<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
        <el-breadcrumb-item>工单查询</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-col :span="24" class="warp-main">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters" ref="filterForm">
          <el-form-item label="工单号" prop="workOrderNo">
            <el-input v-model="filters.workOrderNo" placeholder="工单号"></el-input>
          </el-form-item>
          <el-form-item label="项目" prop="projectId">
            <el-select v-model="filters.projectId" placeholder="项目" filterable clearable>
              <el-option 
                v-for="(item,index) in projectSelects"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button type="primary" @click="showAddWorkOrderDialog">添加</el-button>
            <el-button type="primary" @click="resetFilterForm">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="workorderDatas" highlight-current-row border>
        <el-table-column type="index" width="50" fixed="left"></el-table-column>
        <el-table-column prop="workOrderNo" label="工单号" width="180" sortable></el-table-column>
        <el-table-column prop="workSubject" label="工单主题" width="120" sortable></el-table-column>
        <el-table-column prop="workContent" label="工单内容" width="160" :show-overflow-tooltip="true" sortable></el-table-column>
        <el-table-column prop="state" label="工单状态" width="110" :formatter="workOrderStateFormatter" sortable></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" width="120" sortable></el-table-column>
        <el-table-column prop="eventName" label="告警名称" width="120" sortable></el-table-column>
        <el-table-column prop="eventHappenTime" label="告警发生时间" width="160" sortable></el-table-column>
        <el-table-column prop="safeUserName" label="保障人员" width="110" sortable></el-table-column>
        <!-- <el-table-column prop="handleType" label="处理方式" width="110" :formatter="handleTypeFormatter" sortable></el-table-column> -->
        <el-table-column prop="handleContent" label="处理结果" width="110" sortable></el-table-column>
        <el-table-column prop="handleDate" label="处理时间" min-width="160" sortable></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="160" sortable></el-table-column>
        <el-table-column label="操作" fixed="right" min-width="320">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="showEditWorkOrderDialog(scope.$index,scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="removeWorkOrder(scope.$index,scope.row)">删除</el-button>
            <el-button size="mini" type="primary" @click="workOrderPush(scope.$index,scope.row)">推送</el-button>
            <el-button size="mini" v-if="scope.row.state == '6'" type="primary" @click="viewWorkOrder(scope.$index,scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]"
          :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
      </el-col>

      <!-- 新增工单弹窗 -->
      <el-dialog title="新增工单" :visible.sync="addWorkOrderForm.visible" :close-on-click-modal="false" width="30%">
        <el-form :model="addWorkOrderForm.data" label-width="80px" :rules="rules" ref="addWorkOrderForm">
          <el-row>
            <el-col :span="24">
              <el-form-item label="工单主题" prop="workSubject">
                <el-input v-model="addWorkOrderForm.data.workSubject" placeholder="工单主题" maxlength="30" auto-complete="off" :show-word-limit="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="工单内容" prop="workContent">
                <el-input type="textarea" v-model="addWorkOrderForm.data.workContent" placeholder="工单内容" rows="4" maxlength="80" auto-complete="off" :show-word-limit="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="关联设备" prop="deviceName">
                <el-input placeholder="请选择" v-model="addWorkOrderForm.data.deviceName" disabled auto-complete="off">
                  <el-button type="primary" slot="append" @click.prevent="showDeviceDialog" :class="'button-primary'">选择</el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="关联告警" prop="eventName">
                <el-input placeholder="请选择" v-model="addWorkOrderForm.data.eventName" disabled auto-complete="off">
                  <el-button type="primary" slot="append" @click.prevent="showEventDialog" :class="addWorkOrderForm.isEventSelectable?'button-primary':'button-disable'">选择</el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 
          <el-row>
            <el-col :span="24">
              <el-form-item label="派单方式" prop="handleType">
                <el-radio-group v-model="addWorkOrderForm.data.handleType">
                  <el-radio v-for="(item,index) in handleTypeDatas" :key="index" :label="item.value">{{item.label}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
           -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addWorkOrderForm.visible=false">取消</el-button>
          <el-button type="primary" @click.native="addWorkOrderFormSubmit" :loading="loading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 编辑工单弹窗 -->
      <el-dialog title="编辑工单" :visible.sync="editWorkOrderForm.visible" :close-on-click-modal="false" width="30%">
        <el-form :model="editWorkOrderForm.data" label-width="80px" :rules="rules" ref="editWorkOrderForm">
          <el-input v-model="editWorkOrderForm.data.id" type="hidden"></el-input>
          <el-row>
            <el-col :span="24">
              <el-form-item label="工单号" prop="workOrderNo">
                <el-input v-model="editWorkOrderForm.data.workOrderNo" placeholder="工单号" disabled maxlength="30" auto-complete="off" :show-word-limit="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="工单主题" prop="workSubject">
                <el-input v-model="editWorkOrderForm.data.workSubject" placeholder="工单主题" maxlength="30" auto-complete="off" :show-word-limit="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="工单内容" prop="workContent">
                <el-input type="textarea" v-model="editWorkOrderForm.data.workContent" placeholder="工单内容" rows="4" maxlength="80" auto-complete="off" :show-word-limit="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="关联设备" prop="deviceName">
                <el-input placeholder="请选择" v-model="editWorkOrderForm.data.deviceName" disabled auto-complete="off">
                  <el-button type="primary" slot="append" @click.prevent="showDeviceDialog" :class="'button-primary'">选择</el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="关联告警" prop="eventName">
                <el-input placeholder="请选择" v-model="editWorkOrderForm.data.eventName" disabled auto-complete="off">
                  <el-button type="primary" slot="append" @click.prevent="showEventDialog" :class="editWorkOrderForm.isEventSelectable?'button-primary':'button-disable'">选择</el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 
          <el-row>
            <el-col :span="24">
              <el-form-item label="派单方式" prop="handleType">
                <el-radio-group v-model="editWorkOrderForm.data.handleType">
                  <el-radio v-for="(item,index) in handleTypeDatas" :key="index" :label="item.value">{{item.label}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
           -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editWorkOrderForm.visible=false">取消</el-button>
          <el-button type="primary" @click.native="editWorkOrderFormSubmit" :loading="loading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 设备列表弹窗 -->
      <el-dialog title="设备" :visible.sync="device.visible" :close-on-click-modal="false" width="70%">
        <el-form :inline="true" :model="device.filters" ref="deviceFiltersForm">
          <el-form-item label="项目" prop="projectId">
            <el-select v-model="device.filters.projectId" placeholder="项目" filterable clearable>
              <el-option 
                v-for="(item,index) in projectSelects"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备号" prop="deviceCode">
            <el-input v-model="device.filters.deviceCode" placeholder="设备号" style="min-width: 240px;"></el-input>
          </el-form-item>
          <el-form-item label="设备短号" prop="deviceShortcode">
            <el-input v-model="device.filters.deviceShortcode" placeholder="设备短号" style="min-width: 240px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleDeviceSearch">查询</el-button>
            <el-button type="primary" @click="resetDeviceFiltersForm()">重置</el-button>
          </el-form-item>
        </el-form>
        <el-table
          border
          ref="deviceTable"
          :row-key="deviceTableRowKey"
          :data="device.pageDatas"
          tooltip-effect="dark"
          class="selection-table"
          @select="handleDeviceSelect">
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column prop="deviceCode" label="设备号" width="160"></el-table-column>
          <el-table-column prop="deviceShortcode" label="设备短号" width="160"></el-table-column>
          <el-table-column prop="deviceSn" label="设备型号" width="160"></el-table-column>
          <el-table-column prop="deviceName" label="设备名称" width="160"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" width="160"></el-table-column>
          <el-table-column prop="addressDetail" label="设备地址" width="280" :formatter="addressDetailFormatter" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="devicePosition" label="位置" align="center" :show-overflow-tooltip="true"></el-table-column> 
        </el-table> 
        <!--分页工具条-->
        <el-pagination @size-change="handleDeviceSizeChange" @current-change="handleDeviceCurrentChange" :page-sizes="[10, 20, 50, 100]"  :current-page.sync="device.current" :page-size="10" background layout="total, sizes, prev, pager, next, jumper" :total="device.total" style="float:right;">
        </el-pagination> 
        <div slot="footer" class="dialog-footer" style="margin: 20px 0 0 0">
          <el-button @click.native="device.visible = false">取消</el-button>
          <el-button type="primary" @click.native="handleDeviceSelectionConfirm">确认</el-button>
        </div>
      </el-dialog>

      <!-- 告警列表弹窗 -->
      <el-dialog title="告警" :visible.sync="event.visible" :close-on-click-modal="false" width="70%">
        <el-form :inline="true" :model="event.filters" ref="eventFiltersForm">
          <el-form-item label="事件类别" prop="eventTypeId">
            <el-select  v-model="event.filters.eventTypeId" placeholder="事件类别">
                <el-option v-for="(item,index) in event.eventTypeDatas" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label='告警发生时间' prop="date">
            <el-date-picker
              v-model="event.filters.date"
              class="date-picker"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleEventSearch">查询</el-button>
            <el-button type="primary" @click="resetEventFiltersForm()">重置</el-button>
          </el-form-item>
        </el-form>
        <!--列表-->
        <el-table 
          border
          ref="eventTable"
          :row-key="eventTableRowKey"
          :data="event.pageDatas"
          tooltip-effect="dark"
          class="selection-table"
          @select="handleEventSelect">
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column prop="deviceCode" label="设备号" width="140"  align="center"></el-table-column>
          <el-table-column prop="deviceShortcode" label="设备短号" width="140"  align="center"></el-table-column>
          <el-table-column prop="deviceSn" label="型号" width="80"  align="center"></el-table-column>
          <el-table-column prop="projectName" label="项目" width="180" align="center"></el-table-column>
          <el-table-column prop="happedTime" label="告警发生时间" width="160" align="center"></el-table-column>
          <el-table-column prop="eventName" label="告警类别" width="120"  align="center" style="color:red">
            <template slot-scope="scope">
              <el-tag><font :color="scope.row.colorValue">{{scope.row.eventName}}</font></el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="eventState" label="告警状态" width="120"  align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.eventState ===0" style="color:red">未解除</el-tag>
              <el-tag v-if="scope.row.eventState ===1" style="color:green">已解除</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sureState" label="确认情况" width="120"  align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.sureState ===0" style="color:red">未确认</el-tag>
              <el-tag v-if="scope.row.sureState ===1" style="color:green">已确认</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="noteState" label="通知情况" width="120"  align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.noteState ===0" style="color:red">未通知</el-tag>
              <el-tag v-if="scope.row.noteState ===1" style="color:green">通知已送达</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="addressDetail" label="地址" width="200" align="center" :formatter="addressDetailFormatter" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="position" label="位置" align="center" :show-overflow-tooltip="true"></el-table-column> 
        </el-table>
        <!--分页工具条-->
        <el-pagination @size-change="handleEventSizeChange" @current-change="handleEventCurrentChange" :page-sizes="[10, 20, 50, 100]"
          :page-size="20" background layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right;">
        </el-pagination>
        <div slot="footer" class="dialog-footer" style="margin: 20px 0 0 0">
          <el-button @click.native="event.visible = false">取消</el-button>
          <el-button type="primary" @click.native="handleEventSelectionConfirm">确认</el-button>
        </div>
      </el-dialog>

      <!--推送列表-->
      <el-dialog id="pushList" title="通知列表" :visible.sync="push.formVisible" :close-on-click-modal="false" width="96%">
            <!--列表-->
            <el-table :data="push.data" highlight-current-row v-loading="loading" border style="width: 100%;"  :row-class-name="tableRowClassName">>
                <el-table-column type="index" label="序号" width="50" fixed="left" align="center"></el-table-column>
                <el-table-column prop="safeUserName" label="推送人" width="200"  align="center"></el-table-column>
                <el-table-column prop="orgName" label="单位" width="200"  align="center"></el-table-column>
                <el-table-column prop="pushTime" label="推送时间" width="180"  align="center"></el-table-column>
                <el-table-column prop="isDelete" label="状态" width="150"  align="center"></el-table-column>
                <el-table-column prop="msgId" label="微信消息ID" width="180" align="center"></el-table-column>
                <el-table-column prop="msgStateCode" label="状态码" width="180" align="center"></el-table-column>
                <el-table-column prop="msgText" label="描述" align="center" style="color:red"></el-table-column>
                <el-table-column label="操作" width="150"  align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isDelete==0"  @click="push.rePush(scope.index,scope.row)" style="cursor:pointer">
                            <el-tag style="color:red">推送</el-tag>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <!--推送列表-->
      <el-dialog title="图片列表" :visible.sync="imageDialogVisible">
        <div class="image-wrapper">
          <div v-if="imageList.length <= 0">暂无图片</div>
          <div v-else v-for="(url, index) in imageList" :key="index" class="image-item">
            <el-image 
              class="image-item-body"
              :src="url"
              :preview-src-list="imageList"
              lazy>
            </el-image>
          </div>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
  import API from "../../api/device/api_workorder";
  import DEVICE_API from "../../api/api_device";
  import PROJECT_API from '../../api/api_project';
  import EVENT_API from '../../api/device/api_event';
  import EVENTTYPE_API from '../../api/device/api_deviceEventDictionary';
  import DICT_API from "../../api/api_dict";
  export default {
    data() {
      return {
        loading:false,
        total: 0,
        page: 1,
        limit: 10,
        workorderDatas: [],
        projectSelects: [],
        handleTypeDatas: [],
        workOrderStates: [],
        imageList: [],
        imageDialogVisible: false,
        //条件
        filters:{},
        //验证规则
        rules: {
          workSubject: [
            {required: true, message: "请输入工单主题", trigger:'blur'}
          ],
          workContent: [
            {required: true, message: "请输入工单内容", trigger:'blur'}
          ],
          deviceName: [
            {required: true, message: "请关联设备", trigger:'blur'}
          ]
        },   
        //新增工单 
        addWorkOrderForm: {
          visible: false,
          device: null,
          event: null,
          isEventSelectable: false,
          defaultData: {
            handleType: "0"
          },
          data: {}
        },
        editWorkOrderForm: {
          visible: false,
          device: null,
          event: null,
          isEventSelectable: false,
          data: {}
        },
        //设备
        device: {
          total: 0,
          page: 1,
          limit: 10,
          visible: false, //设备弹窗显示
          //查询条件
          filters: {},
          pageDatas: [], //表格数据
          selectedRow: null //选中的设备
        },
        //告警
        event: {
          total: 0,
          page: 1,
          limit: 10,
          visible: false, //设备弹窗显示
          //查询条件
          filters: {},
          pageDatas: [], //表格数据
          selectedRow: null, //选中的设备
          eventTypeDatas: [] //事件类型下拉框数据
        },
        //推送数据模型
        push:{
          formVisible:false,
          data:[],
          rePush:function(a,b){}
        }
      };
    },
    watch: {
      'device.pageDatas': 'toggleDeviceTableRowSelection',
      'event.pageDatas': 'toggleEventTableRowSelection',
      'addWorkOrderForm.device': 'resetEvent',
      'editWorkOrderForm.device': 'resetEvent',
    },
    methods:{
      tableRowClassName:function({row, rowIndex}){
        if (row.isDelete == 1) {
          return 'delete';
        } 
        return '';
      },
      getMyProject: function(query, callback){
        let that = this;
        PROJECT_API.projectCombox()
        .then(
          function(result){
          if (result && result.code == 200) {
             that.projectSelects = result.data;
             if(callback) {
                 callback();
             }
          }
          },
          function(error){
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error){
          that.$message.error({
            showClose: true,
            message: '请求出现异常!',
            duration: 2000
          });
        });
      },
      // getHandleType() {
      //   let that = this;
      //   DICT_API.combox('workorder_handletype')
      //   .then(
      //     function (result) {
      //       if (result && result.code == 200) {
      //         that.handleTypeDatas = result.data;
      //       }
      //     },
      //     function (err) {
      //       that.$message.error({
      //         showClose: true,
      //         message: err.toString(),
      //         duration: 2000
      //       });
      //     }
      //   )
      //   .catch(function(error){
      //     that.$message.error({
      //       showClose: true,
      //       message: "请求出现异常",
      //       duration: 2000
      //     });
      //   });
      // },
      // handleTypeFormatter(row, column, cellValue, index) {
      //   let text = '';
      //   for(let index = 0; index < this.handleTypeDatas.length; index++){
      //     if (row.handleType.toString() === this.handleTypeDatas[index].value){
      //       text = this.handleTypeDatas[index].label;
      //       break;
      //     }
      //   }
      //   return text;
      // },
      getWorkOrderState() {
        let that = this;
        DICT_API.combox('workorder_state')
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.workOrderStates = result.data;
            }
          },
          function (err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error){
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
      },
      workOrderStateFormatter(row, column, cellValue, index) {
        let text = '';
        for(let index = 0; index < this.workOrderStates.length; index++){
          if (row.state.toString() === this.workOrderStates[index].value){
            text = this.workOrderStates[index].label;
            break;
          }
        }
        return text;
      },
      resetFilterForm() {
        this.$refs.filterForm.resetFields();
        this.handleSearch();
      },
      handleSearch() {
        this.total = 0;
        this.page = 1;
        this.search();
      },
      //获取工单列表
      search: function () {
        let that = this;
        let params = Object.assign({
          page: that.page,
          limit: that.limit,
        }, that.filters);
        API.pageList(params)
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.total = result.data.total;
              that.workorderDatas = result.data.records;
            }
          },
          function (err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
      },
      handleSizeChange(val) {
        this.limit = val;
        this.search();
      },
      handleCurrentChange(val) {
        this.page = val;
        this.search();
      },
      //添加工单
      showAddWorkOrderDialog(){
        let that = this;
        this.addWorkOrderForm.data = Object.assign({}, this.addWorkOrderForm.defaultData);
        this.addWorkOrderForm.device = null;
        this.addWorkOrderForm.isEventSelectable = false;
        this.addWorkOrderForm.visible = true;
        this.$nextTick(() => {
          this.$refs.addWorkOrderForm.clearValidate();
        });
      },
      addWorkOrderFormSubmit() {
        let that = this;
        this.$refs.addWorkOrderForm.validate((valid) => {
          if (valid) {
            let params = Object.assign({}, this.addWorkOrderForm.data);
            that.loading = true;
            API.saveWorkOrder(params)
            .then(
              function(result){
                that.loading = false;
                if (result && result.code == 200 
                  && result.data && result.data === true) {
                  that.$message.success({
                    showClose: true,
                    message: '新增成功!',
                    duration: 2000
                  });
                  that.$refs.addWorkOrderForm.resetFields();
                  that.addWorkOrderForm.visible = false;
                  that.handleSearch();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: '新增失败!',
                    duration: 2000
                  });
                }
              },
              function(error){
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: error.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error){
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: '请求出现异常!',
                duration: 2000
              });
            });
          }
          if (this.addWorkOrderForm.data.deviceName) {
            this.$refs.addWorkOrderForm.clearValidate('deviceName');
          }
        });
      },
      //编辑工单
      showEditWorkOrderDialog(index,row) {
        let that = this;
        this.editWorkOrderForm.data = Object.assign({}, {
          id: row.id,
          workOrderNo: row.workOrderNo,
          workSubject: row.workSubject,
          workContent: row.workContent,
          deviceId: row.deviceId,
          deviceName: row.deviceName,
          eventId: row.eventId,
          eventName: row.eventName,
          safeUserId: row.safeUserId,
          safeUserName: row.safeUserName,
          handleType: row.handleType.toString()
        });
        this.editWorkOrderForm.device = row.deviceId? Object.assign({}, {
          id: row.deviceId,
          deviceName: row.deviceName
        }): null;
        this.editWorkOrderForm.event = row.eventId? Object.assign({}, {
          id: row.eventId,
          eventName: row.eventName
        }): null;
        this.editWorkOrderForm.isEventSelectable = this.editWorkOrderForm.data.deviceId? true: false;
        this.editWorkOrderForm.visible = true;
        this.$nextTick(() => {
          this.$refs.editWorkOrderForm.clearValidate();
        });
      },
      editWorkOrderFormSubmit() {
        let that = this;
        this.$refs.editWorkOrderForm.validate((valid) => {
          if (valid) {
            let params = Object.assign({}, this.editWorkOrderForm.data);
            that.loading = true;
            API.updateWorkOrder(params)
            .then(
              function(result){
                that.loading = false;
                if (result && result.code == 200 
                  && result.data && result.data === true) {
                  that.$message.success({
                    showClose: true,
                    message: '修改成功!',
                    duration: 2000
                  });
                  that.$refs.editWorkOrderForm.resetFields();
                  that.editWorkOrderForm.visible = false;
                  that.handleSearch();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: '修改失败!',
                    duration: 2000
                  });
                }
              },
              function(error){
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: error.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error){
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: '请求出现异常!',
                duration: 2000
              });
            });
          }
          if (this.editWorkOrderForm.data.deviceName) {
            this.$refs.editWorkOrderForm.clearValidate('deviceName');
          }
        });
      },
      //删除工单
      removeWorkOrder(index,row){
        let that = this;
        this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'})
        .then(function(){
          API.removeWorkOrder(row.id)
          .then(
            function (result) {
              if (result && result.code === 200 
                && result.data && result.data === true) {
                that.$message.success({
                  showClose: true,
                  message: '删除成功',
                  duration: 1500
                });
                that.search();
              }
            }, 
            function (err) {
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error){
            that.$message.error({
              showClose: true,
              message: '请求出现异常',
              duration: 2000
            });
          })
        })
        .catch(function(error){
          //取消删除
        });
      },
      //推送列表
      workOrderPush:function(index,row){
            let that =this;
            that.push.formVisible=true;
            API.getPushList({workId:row.id})
            .then(
                function(result){
                    if (result && result.code == 200) {
                       that.push.data = result.data;
                    }
                },
                function(error){
                    that.$message.error({
                        showClose: true,
                        message: error.toString(),
                        duration: 2000
                    });
                }
            )
            .catch(function(error){
                that.$message.error({
                showClose: true,
                message: '请求出现异常',
                duration: 2000
                });
            });

            //绑定推送
            that.push.rePush=function(pindex,prow){
                //调用推送接口
                API.rePush(prow.id)
                 .then(
                    function(result){
                        if (result && result.code == 200) {
                        that.workOrderPush(index,row);
                        }
                    },
                    function(error){
                        that.$message.error({
                            showClose: true,
                            message: error.toString(),
                            duration: 2000
                        });
                    }
                )
                .catch(function(error){
                    that.$message.error({
                    showClose: true,
                    message: '请求出现异常',
                    duration: 2000
                    });
                });
            }
      },
      viewWorkOrder (index,row) {
        let that = this;
        let params = {
          workId: row.id
        }
        API.getImageList(params)
        .then(
            function(result){
                if (result && result.code == 200) {
                  that.imageList = [];
                  result.data.forEach(item => {
                    that.imageList.push(item.imageUrl);
                  });
                }
                that.imageDialogVisible = true;
            },
            function(error){
                that.$message.error({
                    showClose: true,
                    message: error.toString(),
                    duration: 2000
                });
            }
        )
        .catch(function(error){
            that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
            });
        });
      },
      handleDeviceSearch(successCallback) {
        this.device.total = 0;
        this.device.page = 1;
        this.deviceSearch(successCallback);
      },
      //定义查询方法
      deviceSearch(successCallback){
        let that = this;
        let params = Object.assign({
          page: this.device.page,
          limit: this.device.limit
        }, this.device.filters);
        DEVICE_API.devicePageList(params)
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.device.total = result.data.total;
              that.device.pageDatas = result.data.records;
            }
            if (typeof successCallback === 'function') {
              successCallback(result);
            }
          },
          function (err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
      },
      resetDeviceFiltersForm() {
        this.$refs['deviceFiltersForm'].resetFields();
        this.handleDeviceSearch();
      },
      addressDetailFormatter(row, column, cellValue, index){
        return row.provinceName + row.cityName + row.districtName + row.addressDetail;
      },
      handleDeviceSizeChange:function(val){
        this.device.limit = val;
        this.deviceSearch();
      },
      handleDeviceCurrentChange: function(val) {
        this.device.page = val;
        this.deviceSearch();
      },
      //弹窗设备弹窗
      showDeviceDialog(){
        let that = this;
        this.device.filters = {};
        this.handleDeviceSearch(function(){
          that.device.visible = true;
        });
      },
      toggleDeviceTableRowSelection(datas) {
        this.$nextTick(function(){
          this.$refs.deviceTable.clearSelection();
          if (this.addWorkOrderForm.device || this.editWorkOrderForm.device) {
            let device = this.addWorkOrderForm.visible? this.addWorkOrderForm.device: this.editWorkOrderForm.device;
            for (let index = 0; index < datas.length; index++) {
              if(device.id === datas[index].id){
                console.log("toggleDeviceTableRowSelection", datas[index]);
                this.$refs.deviceTable.toggleRowSelection(datas[index], true);
                break;
              }
            }
          }
        });
      },
      deviceTableRowKey(row) {
        return row.id;
      },
      handleDeviceSelect(selection, row) {
        console.log("handleDeviceSelect")
        this.$refs.deviceTable.clearSelection();
        if (selection.length > 0) {
          this.device.selectedRow = row;
          this.$refs.deviceTable.toggleRowSelection (row, true);
          return;
        }
        this.device.selectedRow = null;
      },
      handleDeviceSelectionConfirm() {
        if (this.device.selectedRow) {
          if (this.addWorkOrderForm.visible) {
            this.addWorkOrderForm.data.deviceId = this.device.selectedRow.id;
            this.addWorkOrderForm.data.deviceName = this.device.selectedRow.deviceName;
            this.$refs.addWorkOrderForm.clearValidate('deviceName');
            this.addWorkOrderForm.isEventSelectable = true;
            this.addWorkOrderForm.device = this.device.selectedRow;
          }
          if (this.editWorkOrderForm.visible) {
            this.editWorkOrderForm.data.deviceId = this.device.selectedRow.id;
            this.editWorkOrderForm.data.deviceName = this.device.selectedRow.deviceName;
            this.$refs.editWorkOrderForm.clearValidate('deviceName');
            this.editWorkOrderForm.isEventSelectable = true;
            this.editWorkOrderForm.event = null;
            this.editWorkOrderForm.device = this.device.selectedRow;
          }
        } else {
          if (this.addWorkOrderForm.visible) {
            this.addWorkOrderForm.device = null;
            this.addWorkOrderForm.data.deviceId = null;
            this.addWorkOrderForm.data.deviceName = null;
            this.addWorkOrderForm.isEventSelectable = false;
          }
          if (this.editWorkOrderForm.visible) {
            this.editWorkOrderForm.device = null;
            this.editWorkOrderForm.data.deviceId = null;
            this.editWorkOrderForm.data.deviceName = null;
            this.editWorkOrderForm.isEventSelectable = false;
          }
        }
        this.device.visible = false;
      },

      resetEvent(value){
        if (this.addWorkOrderForm.visible) {
          this.addWorkOrderForm.data.eventId = null;
          this.addWorkOrderForm.data.eventName = null;
          this.addWorkOrderForm.event = null;
        }
        if (this.editWorkOrderForm.visible
           && !this.editWorkOrderForm.event) {
          this.editWorkOrderForm.data.eventId = null;
          this.editWorkOrderForm.data.eventName = null;
          this.editWorkOrderForm.event = null;
        }
      },
      showEventDialog(){
        let that = this;
        if (this.addWorkOrderForm.device || this.editWorkOrderForm.device) {
          this.getEventTypeComboxList();
          this.event.filters = {};
          this.event.filters.deviceId  = this.addWorkOrderForm.visible? 
                this.addWorkOrderForm.device.id: this.editWorkOrderForm.device.id;
          this.handleEventSearch(function(){
            that.event.visible = true;
          });
        }
      },
      toggleEventTableRowSelection(datas) {
        this.$nextTick(function(){
          this.$refs.eventTable.clearSelection();
          if (this.editWorkOrderForm.event){
            for (let index = 0; index < datas.length; index++) {
              if(this.editWorkOrderForm.event.id === datas[index].id){
                console.log("toggleEventTableRowSelection", datas[index]);
                this.$refs.eventTable.toggleRowSelection(datas[index], true);
                break;
              }
            }
          }
        });
      },
      getEventTypeComboxList(successCallback) {
        let that = this;
        EVENTTYPE_API.getComboxList()
        .then(
          function(result){
            if (result && result.code == 200) {
              that.event.eventTypeDatas= result.data;
            }
            if (typeof successCallback === 'function') {
              successCallback(result);
            }
          },
          function(error){
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error){
          that.$message.error({
            showClose: true,
            message: '请求出现异常',
            duration: 2000
          });
        });
      },
      handleEventSearch(successCallback) {
        this.event.total = 0;
        this.event.page = 1;
        this.eventSearch(successCallback);
      },
      //定义告警查询方法
      eventSearch(successCallback){
        let that = this;
        let params = Object.assign({
          page: this.event.page,
          limit: this.event.limit
        }, this.event.filters);
        EVENT_API.getList(params)
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.event.total = result.data.total;
              that.event.pageDatas = result.data.records;
            }
            if (typeof successCallback === 'function') {
              successCallback(result);
            }
          },
          function (err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
      },
      resetEventFiltersForm() {
        this.$refs['eventFiltersForm'].resetFields();
        this.handleEventSearch();
      },
      handleEventSizeChange:function(val){
        this.event.limit = val;
        this.eventSearch();
        
      },
      handleEventCurrentChange:function(val){
        this.event.page = val;
        this.eventSearch();
      },
      eventTableRowKey(row) {
        return row.id;
      },
      handleEventSelect(selection, row) {
        this.$refs.eventTable.clearSelection();
        if (selection.length > 0) {
          this.event.selectedRow = row;
          this.$refs.eventTable.toggleRowSelection (row, true);
          return;
        }
        this.event.selectedRow = null;
      },
      handleEventSelectionConfirm() {
        if (this.event.selectedRow) {
          if (this.addWorkOrderForm.visible) {
            this.addWorkOrderForm.event = this.event.selectedRow;
            this.addWorkOrderForm.data.eventId = this.event.selectedRow.id;
            this.addWorkOrderForm.data.eventName = this.event.selectedRow.eventName;
          }
          if (this.editWorkOrderForm.visible) {
            this.editWorkOrderForm.event = this.event.selectedRow;
            this.editWorkOrderForm.data.eventId = this.event.selectedRow.id;
            this.editWorkOrderForm.data.eventName = this.event.selectedRow.eventName;
          }
        } else {
          if (this.addWorkOrderForm.visible) {
            this.addWorkOrderForm.event = null;
            this.addWorkOrderForm.data.eventId = null;
            this.addWorkOrderForm.data.eventName = null;
          }
          if (this.editWorkOrderForm.visible) {
            this.editWorkOrderForm.event = null;
            this.editWorkOrderForm.data.eventId = null;
            this.editWorkOrderForm.data.eventName = null;
          }
        }
        this.event.visible = false;
      }
    },
    mounted() {
      this.getMyProject();
      // this.getHandleType();
      this.getWorkOrderState();
      this.handleSearch();
    }
  };
</script>
<style lang="scss" scoped="">
  .button-primary {
    color: #FFF!important;
    background-color: #409EFF!important;
    border-color: #409EFF!important;
    border-radius: 0!important;
  }
  .button-disable {
    cursor: not-allowed;
  }
  .image-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    .image-item {
      box-sizing: content-box;
      padding: 0 0 20px 0;

      .image-item-body {
        width: 210px;
        height: 210px;
        box-sizing: content-box;
        padding: 2px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      }
    }
  }
</style>
<style lang="scss">
  .selection-table {
    width: 100%;
  }
  .selection-table .el-table__header-wrapper .el-checkbox{
    background-color: red;
    display: none!important;
  }
  .date-picker .el-range-separator {
    padding: 0!important;
  }
</style>


// WEBPACK FOOTER //
// list.vue?4710f07b